import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Stars",
  "use": "icon-Stars-usage",
  "viewBox": "0 0 87 99",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 87 99\" id=\"icon-Stars\">\n<path fill-rule=\"evenodd\" d=\"M0.000,88.000 L0.000,98.000 L33.000,79.000 L67.000,99.000 L60.000,57.000 L87.000,28.000 L50.000,22.000 L40.000,0.000 L25.000,0.000 L15.000,22.000 L0.000,24.000 L0.000,53.000 L5.000,57.000 L0.000,88.000 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Stars.svg
// module id = YuGM
// module chunks = 70